/* eslint-disable react/prop-types */
import React, { memo } from 'react';

import { Link, Link as RouterLink } from 'react-router-dom';

export function TeamMemberLink({ eventId, id, displayName, eventGroupId }) {
  if (id) {
    const path = eventGroupId
      ? `/event-group/${eventGroupId}/events/${eventId}/members/${id}`
      : `/event/${eventId}/members/${id}`;
    return (
      <Link component={RouterLink} to={path}>
        {displayName}
      </Link>
    );
  }
  return null;
}

export default memo(TeamMemberLink);
